import type { IconData } from '@stacksjs/iconify-core'

export const pottedFlower: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 26v8m6.053-26.332a6.366 6.366 0 0 0-12.106 0a6.366 6.366 0 0 0-3.742 11.514A6.367 6.367 0 0 0 24 26.298a6.366 6.366 0 0 0 9.795-7.116a6.366 6.366 0 0 0-3.742-11.514\"/><path d=\"M24 12a4 4 0 1 1 0 8a4 4 0 0 1 0-8M12.03 35.855c.114-1.16 1.21-1.758 2.377-1.78A513 513 0 0 1 24 34c4.696 0 7.816.041 9.593.075c1.167.022 2.263.62 2.376 1.78a6.6 6.6 0 0 1 0 1.29c-.111 1.139-1.169 1.735-2.31 1.778a80 80 0 0 1-.578 2.584c-.504 2.076-2.293 3.409-4.428 3.453c-1.155.023-2.673.04-4.653.04s-3.497-.017-4.653-.04c-2.135-.044-3.924-1.377-4.428-3.453a80 80 0 0 1-.577-2.584c-1.142-.043-2.2-.639-2.312-1.778a6.6 6.6 0 0 1 0-1.29\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pottedFlower
